import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ComponentHeader from '../ecap/ComponentHeader';
import { getOnboardingState, getEcapState } from '../../store/selectors';
import { setModalImage, getUserDashboardInfo } from '../../store/actions';
import Loading from '../utility/Loading';
import ModalController from '../utility/modal/ModalController';
import CareerCarousel from './utility/CareerCarousel';

function Top25Careers(props) {
  const { tenant } = { ...props };
  const { t } = useTranslation();

  const careerGameResults = () => {
    if (props.location.pathname.includes('user-profile')) {
      return props.userProfile?.careerGameResults.length > 0;
    }
    return props.onboarding.userData.careerGameResults.length > 0;
  };

  return (
    <>
      <ModalController />
      <ComponentHeader
        parent="dashboard"
        headerText={
          props.location.pathname.includes('user-profile')
            ? t('Top {{number}} Careers', { number: '25' })
            : t('My Top {{number}} Careers', { number: '25' })
        }
        tenant={tenant}
      />
      {careerGameResults() ? (
        <CareerCarousel
          parent="top-25"
          tenant={tenant}
          careerCardSubText={t('View Details')}
          careerList={
            props.location.pathname.includes('user-profile')
              ? props.userProfile?.careerGameResults
              : props.onboarding.userData.careerGameResults
          }
          setModalImage
          userProfileFavorites={props.favorites}
        />
      ) : (
        <Loading />
      )}
    </>
  );
}
function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const ecap = getEcapState(state);
  const userProfile = state.admin.userProfileInfo;

  return { onboarding, ecap, userProfile };
}

export default withRouter(
  connect(mapStateToProps, { setModalImage, getUserDashboardInfo })(
    Top25Careers
  )
);
